export default {
  DELIVERY_ADDRESS: 'DELIVERY_ADDRESS',
  REFERENCE: 'REFERENCE',
  COMMENT: 'COMMENT',
  ADD_BASKET_MESSAGE: 'ADD_BASKET_MESSAGE',
  REMOVE_BASKET_MESSAGE: 'REMOVE_BASKET_MESSAGE',
}
